import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import React from 'react'
import { useDispatch } from 'react-redux'
import { setShowQuizModal } from '../../redux/lessonQuizSlice'

const QuizCompletionModal = ({ isOpen, setIsOpen }) => {

    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(setShowQuizModal(false))
        setIsOpen(false)
    }

    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={handleClick}
                as="div"
                className="fixed inset-0 z-[50] flex flex-col justify-center items-center"
            >
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-0 z-10" />
                <Dialog.Title/>
                <Dialog.Description/>
                <div className='w-[90%] max-w-lg z-[9999999] bg-secondary_background p-4 rounded-xl text-white relative border'>
                    <div className='absolute top-3 right-3 cursor-pointer' onClick={handleClick}>
                        <FontAwesomeIcon icon={faXmark} className='text-2xl'/>
                    </div>
                    <div className='w-[180px] lg:w-[298px] lg:h-[181px] h-[110px] mx-auto'>
                        <img src="https://assets.learntube.ai/files/Lead%20Generation/Group.png?updatedAt=1713420806381" alt="" className='w-full h-full' />
                    </div>
                    <h3 className='font-semibold text-center leading-5 mt-6'>Submit all the quizzes from previous modules to mark them as complete.</h3>
                    <p className='text-xs text-white/50 text-center mt-3'>Course completion requires all quizzes to be finished.</p>
                </div>
            </Dialog>
        </div>
    )
}

export default QuizCompletionModal